export interface IMasterDataRetailer {
  retailerId: number;
  retailerKey: string;
  retailerName: string;
  matchRulesCount: number;
  rawAssociationsCount: number;
}

export class MasterDataRetailer {
  private readonly _retailerId: number;
  private readonly _retailerKey: string;
  private readonly _retailerName: string;
  private readonly _matchRulesCount: number;
  private readonly _rawAssociationsCount: number;

  constructor(props: IMasterDataRetailer) {
    this._retailerId = props.retailerId;
    this._retailerKey = props.retailerKey;
    this._retailerName = props.retailerName;
    this._matchRulesCount = props.matchRulesCount;
    this._rawAssociationsCount = props.rawAssociationsCount;
  }

  get retailerId(): number {
    return this._retailerId;
  }
  get retailerKey(): string {
    return this._retailerKey;
  }
  get retailerName(): string {
    return this._retailerName;
  }
  get matchRulesCount(): number {
    return this._matchRulesCount;
  }
  get rawAssociationsCount(): number {
    return this._rawAssociationsCount;
  }

  static from(props: IMasterDataRetailer): MasterDataRetailer {
    return new MasterDataRetailer(props);
  }

  static toJSON(entity: MasterDataRetailer): IMasterDataRetailer {
    return {
      retailerId: entity.retailerId,
      retailerKey: entity.retailerKey,
      retailerName: entity.retailerName,
      matchRulesCount: entity.matchRulesCount,
      rawAssociationsCount: entity.rawAssociationsCount,
    };
  }
}
